import React from 'react';
import { useParams } from 'react-router-dom';
import './CityPage.css';

const CityPage = () => {
  const { cityName } = useParams();
  
  // City-specific data
  const cityData = {
    wardha: {
      title: "Wardha",
      description: "Wardha is best for solar energy due to its excellent sun exposure and growing industrial sector.",
      stats: "Solar Potential: 5.4 kWh/m²/day",
      projects: "15+ Commercial Installations",
      highlight: "Leading in residential solar adoption"
    },
    bhandara: {
      title: "Bhandara",
      description: "Bhandara is best with its agricultural focus benefiting from solar-powered irrigation.",
      stats: "Solar Potential: 5.3 kWh/m²/day",
      projects: "12+ Agricultural Projects",
      highlight: "Solar pump installations booming"
    },
    gondia: {
      title: "Gondia",
      description: "Gondia is best for its forest conservation efforts powered by solar energy.",
      stats: "Solar Potential: 5.2 kWh/m²/day",
      projects: "8+ Eco-friendly Projects",
      highlight: "Green energy hub development"
    },
    nagpur: {
      title: "Nagpur",
      description: "Nagpur is best as Maharashtra's solar capital with maximum installed capacity.",
      stats: "Solar Potential: 5.6 kWh/m²/day",
      projects: "50+ Large Scale Projects",
      highlight: "Orange City turning Green with Solar"
    },
    buldhana: {
      title: "Buldhana",
      description: "Buldhana is best for its community solar projects and cooperative initiatives.",
      stats: "Solar Potential: 5.4 kWh/m²/day",
      projects: "20+ Community Projects",
      highlight: "Model for cooperative solar farming"
    },
    amravati: {
      title: "Amravati",
      description: "Amravati is best with educational institutions adopting solar power extensively.",
      stats: "Solar Potential: 5.5 kWh/m²/day",
      projects: "25+ Institutional Installations",
      highlight: "Solar-powered educational hub"
    },
    yavatmal: {
      title: "Yavatmal",
      description: "Yavatmal is best for cotton farming powered by solar energy solutions.",
      stats: "Solar Potential: 5.3 kWh/m²/day",
      projects: "18+ Agricultural Solar Plants",
      highlight: "Solar revolution in cotton belt"
    },
    washim: {
      title: "Washim",
      description: "Washim is best with its small-scale solar entrepreneurship growth.",
      stats: "Solar Potential: 5.4 kWh/m²/day",
      projects: "30+ Small Business Installations",
      highlight: "Entrepreneur-driven solar adoption"
    },
    gadchiroli: {
      title: "Gadchiroli",
      description: "Gadchiroli is best for tribal area electrification through solar power.",
      stats: "Solar Potential: 5.1 kWh/m²/day",
      projects: "40+ Rural Electrification Projects",
      highlight: "Solar bringing light to remote areas"
    },
    akola: {
      title: "Akola",
      description: "Akola is best with its textile industries transitioning to solar energy.",
      stats: "Solar Potential: 5.5 kWh/m²/day",
      projects: "22+ Industrial Solar Plants",
      highlight: "Textile industry going solar"
    },
    chandrapur: {
      title: "Chandrapur",
      description: "Chandrapur is best for coal-to-solar transition and renewable energy leadership.",
      stats: "Solar Potential: 5.6 kWh/m²/day",
      projects: "35+ Transition Projects",
      highlight: "From coal capital to solar pioneer"
    }
  };

  // Get city data or default
  const city = cityData[cityName?.toLowerCase()] || {
    title: "Our Presence",
    description: "Select a city to view specific information",
    stats: "Click on any city from our presence list",
    projects: "Multiple projects across Maharashtra",
    highlight: "Leading solar solutions provider"
  };

  return (
    <div className="city-page">
      <div className="city-hero">
        <h1>{city.title}</h1>
        <p className="city-tagline">{city.title} is best for solar energy solutions</p>
      </div>

      <div className="city-content">
        <div className="city-info-card">
          <h2>Why {city.title}?</h2>
          <p className="city-description">{city.description}</p>
          
          <div className="city-stats">
            <div className="stat-item">
              <h3>Solar Potential</h3>
              <p>{city.stats}</p>
            </div>
            <div className="stat-item">
              <h3>Projects Completed</h3>
              <p>{city.projects}</p>
            </div>
            <div className="stat-item">
              <h3>Key Highlight</h3>
              <p>{city.highlight}</p>
            </div>
          </div>
        </div>

        <div className="city-map-section">
          <h3>Our Presence in {city.title}</h3>
          <div className="city-map-placeholder">
            {/* You can add an actual map here later */}
            <div className="map-marker">
              <span className="marker-pin"></span>
              <div className="marker-label">{city.title}</div>
            </div>
          </div>
        </div>

        <div className="city-cta">
          <h2>Interested in Solar Solutions for {city.title}?</h2>
          <p>Contact us for a free consultation and site assessment</p>
          <a href="/contact" className="cta-button">Get Free Consultation</a>
        </div>
      </div>
    </div>
  );
};

export default CityPage;






















// import React, { useState, useEffect } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import './CityPage.css';

// const CityPage = () => {
//   const { cityName } = useParams();
//   const [activeTab, setActiveTab] = useState('overview');
//   const [loading, setLoading] = useState(false);

//   // City-specific comprehensive data
//   const cityData = {
//     wardha: {
//       title: "Wardha",
//       tagline: "Solar Pioneer of Vidarbha",
//       description: "Wardha leads in solar energy adoption with excellent sun exposure averaging 5.4 kWh/m²/day and growing industrial demand. Home to prestigious institutions and sustainable communities.",
//       detailedDescription: "Wardha has emerged as a solar energy hub in Maharashtra, with government support and private initiatives driving rapid adoption. The district's flat terrain and clear skies make it ideal for large-scale solar installations.",
//       stats: {
//         solarPotential: "5.4 kWh/m²/day",
//         installedCapacity: "45 MW",
//         projects: "150+",
//         co2Reduced: "25,000 tons/year",
//         savings: "₹3.5 Cr/year"
//       },
//       projects: "15+ Commercial Installations, 200+ Residential",
//       highlight: "Leading in residential solar adoption",
//       keySectors: ["Educational Institutions", "Hospitals", "Textile Industries", "Agriculture"],
//       subsidy: "40% state subsidy available for residential installations",
//       contactPerson: "Mr. Rajesh Sharma",
//       contactNumber: "+91 9876543210",
//       email: "wardha@solarsolutions.com",
//       officeAddress: "Solar Tower, Wardha Road, Wardha - 442001",
//       testimonials: [
//         "Wardha Institute saved 60% on electricity bills after solar installation.",
//         "Perfect solution for our hospital's power needs - reliable and cost-effective."
//       ],
//       services: ["Rooftop Solar", "Solar Water Pumps", "Industrial Solar Plants", "Solar Street Lights"],
//       gallery: ["wardha1.jpg", "wardha2.jpg", "wardha3.jpg"]
//     },
//     bhandara: {
//       title: "Bhandara",
//       tagline: "Agricultural Solar Hub",
//       description: "Bhandara's agricultural sector benefits immensely from solar-powered irrigation and processing units, reducing dependence on grid power.",
//       detailedDescription: "Known as the 'Rice Bowl of Maharashtra', Bhandara has transformed its agricultural practices with solar energy. Farmers enjoy uninterrupted power for irrigation and reduced operational costs.",
//       stats: {
//         solarPotential: "5.3 kWh/m²/day",
//         installedCapacity: "32 MW",
//         projects: "120+",
//         co2Reduced: "18,000 tons/year",
//         savings: "₹2.8 Cr/year"
//       },
//       projects: "12+ Agricultural Projects, 85+ Solar Pumps",
//       highlight: "Solar pump installations booming",
//       keySectors: ["Agriculture", "Rice Mills", "Dairy Farms", "Rural Enterprises"],
//       subsidy: "Special 45% subsidy for agricultural solar pumps",
//       contactPerson: "Ms. Priya Deshmukh",
//       contactNumber: "+91 9876543211",
//       email: "bhandara@solarsolutions.com",
//       officeAddress: "Green Energy Plaza, Bhandara - 441904",
//       testimonials: [
//         "Solar pumps have doubled our irrigation capacity.",
//         "Rice mill operation costs reduced by 40% with solar."
//       ],
//       services: ["Solar Water Pumps", "Agricultural Processing Units", "Rooftop Solar", "Solar Dryers"],
//       gallery: ["bhandara1.jpg", "bhandara2.jpg"]
//     },
//     nagpur: {
//       title: "Nagpur",
//       tagline: "Solar Capital of Maharashtra",
//       description: "Nagpur leads Maharashtra in solar energy adoption with maximum installed capacity and innovative solar projects across sectors.",
//       detailedDescription: "As the winter capital and largest city in Vidarbha, Nagpur has embraced solar energy through municipal initiatives, corporate adoption, and residential installations. The city aims to become 100% solar-powered by 2030.",
//       stats: {
//         solarPotential: "5.6 kWh/m²/day",
//         installedCapacity: "85 MW",
//         projects: "500+",
//         co2Reduced: "45,000 tons/year",
//         savings: "₹12 Cr/year"
//       },
//       projects: "50+ Large Scale Projects, 300+ Residential",
//       highlight: "Orange City turning Green with Solar",
//       keySectors: ["IT Parks", "Shopping Malls", "Educational Institutions", "Government Buildings"],
//       subsidy: "Up to 40% subsidy available under state policy",
//       contactPerson: "Mr. Amit Joshi",
//       contactNumber: "+91 9876543212",
//       email: "nagpur@solarsolutions.com",
//       officeAddress: "Solar Heights, Sitabuldi, Nagpur - 440012",
//       testimonials: [
//         "IT Park saved ₹50 lakhs annually after switching to solar.",
//         "Best investment for our school - reliable and educational."
//       ],
//       services: ["Commercial Rooftop", "Solar Carports", "Grid-tied Systems", "Solar Consulting"],
//       gallery: ["nagpur1.jpg", "nagpur2.jpg", "nagpur3.jpg", "nagpur4.jpg"]
//     },
//     // Add other cities with similar structure...
//     amravati: {
//       title: "Amravati",
//       tagline: "Educational Solar Hub",
//       description: "Amravati leads in educational institutions adopting solar power, creating sustainable campuses.",
//       detailedDescription: "With numerous educational institutions, Amravati has become a model for solar-powered campuses, reducing carbon footprint while educating future generations about renewable energy.",
//       stats: {
//         solarPotential: "5.5 kWh/m²/day",
//         installedCapacity: "38 MW",
//         projects: "250+",
//         co2Reduced: "22,000 tons/year",
//         savings: "₹4.2 Cr/year"
//       },
//       projects: "25+ Institutional Installations",
//       highlight: "Solar-powered educational hub",
//       keySectors: ["Universities", "Colleges", "Schools", "Research Centers"],
//       subsidy: "Special grants for educational institutions",
//       contactPerson: "Dr. Sunil Patil",
//       contactNumber: "+91 9876543213",
//       email: "amravati@solarsolutions.com",
//       officeAddress: "Knowledge Park, Amravati - 444601",
//       testimonials: [
//         "University reduced energy bills by 70% with solar.",
//         "Perfect solution for our research labs' power needs."
//       ],
//       services: ["Campus Solar", "Solar Labs", "Hostel Power Solutions", "Research Support"],
//       gallery: ["amravati1.jpg", "amravati2.jpg"]
//     },
//     chandrapur: {
//       title: "Chandrapur",
//       tagline: "From Coal to Solar Pioneer",
//       description: "Chandrapur leads the transition from coal dependency to renewable energy leadership in Maharashtra.",
//       detailedDescription: "Historically known for coal mining and thermal power, Chandrapur is now transforming into a solar energy leader with government initiatives and private investments driving the green transition.",
//       stats: {
//         solarPotential: "5.6 kWh/m²/day",
//         installedCapacity: "55 MW",
//         projects: "350+",
//         co2Reduced: "35,000 tons/year",
//         savings: "₹8.5 Cr/year"
//       },
//       projects: "35+ Transition Projects",
//       highlight: "From coal capital to solar pioneer",
//       keySectors: ["Industries", "Mining Areas", "Residential", "Commercial"],
//       subsidy: "Extra 5% subsidy for industries transitioning from coal",
//       contactPerson: "Mr. Vikram Singh",
//       contactNumber: "+91 9876543214",
//       email: "chandrapur@solarsolutions.com",
//       officeAddress: "Green Transition Center, Chandrapur - 442401",
//       testimonials: [
//         "Our factory replaced coal with solar - cleaner and cheaper!",
//         "Perfect solution for sustainable development in mining areas."
//       ],
//       services: ["Industrial Solar", "Mine Reclamation", "Pollution Control", "Energy Transition"],
//       gallery: ["chandrapur1.jpg", "chandrapur2.jpg"]
//     }
//   };

//   // Get city data or default
//   const city = cityData[cityName?.toLowerCase()] || {
//     title: cityName ? cityName.charAt(0).toUpperCase() + cityName.slice(1) : "Our City",
//     tagline: "Solar Energy Solutions",
//     description: "We provide comprehensive solar energy solutions tailored to your city's specific needs and conditions.",
//     detailedDescription: "Our expert team analyzes local conditions, government policies, and energy requirements to deliver optimal solar solutions.",
//     stats: {
//       solarPotential: "5.0+ kWh/m²/day",
//       installedCapacity: "Growing",
//       projects: "Multiple",
//       co2Reduced: "Significant",
//       savings: "Substantial"
//     },
//     projects: "Multiple successful projects",
//     highlight: "Leading solar solutions provider",
//     keySectors: ["All Sectors"],
//     subsidy: "Available as per state policy",
//     contactPerson: "Local Representative",
//     contactNumber: "+91 1800 123 4567",
//     email: "info@solarsolutions.com",
//     officeAddress: "Contact for local office details",
//     testimonials: ["Our customers are happy with our solar solutions."],
//     services: ["All Solar Services"],
//     gallery: []
//   };

//   useEffect(() => {
//     // Scroll to top when city changes
//     window.scrollTo(0, 0);
//     setActiveTab('overview');
    
//     // Simulate loading for better UX
//     setLoading(true);
//     setTimeout(() => setLoading(false), 500);
//   }, [cityName]);

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner"></div>
//         <p>Loading {city.title} solar information...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="city-page">
//       {/* Hero Section */}
//       <div className="city-hero">
//         <div className="hero-overlay">
//           <h1 className="city-title">Solar Energy in {city.title}</h1>
//           <p className="city-tagline">{city.tagline}</p>
//           <p className="city-hero-description">{city.description}</p>
//           <div className="hero-stats">
//             <div className="hero-stat">
//               <span className="stat-value">{city.stats.solarPotential}</span>
//               <span className="stat-label">Solar Potential</span>
//             </div>
//             <div className="hero-stat">
//               <span className="stat-value">{city.stats.installedCapacity}</span>
//               <span className="stat-label">Installed Capacity</span>
//             </div>
//             <div className="hero-stat">
//               <span className="stat-value">{city.stats.projects}+</span>
//               <span className="stat-label">Projects</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Navigation Tabs */}
//       <div className="city-tabs">
//         <button 
//           className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
//           onClick={() => setActiveTab('overview')}
//         >
//           Overview
//         </button>
//         <button 
//           className={`tab-button ${activeTab === 'services' ? 'active' : ''}`}
//           onClick={() => setActiveTab('services')}
//         >
//           Services
//         </button>
//         <button 
//           className={`tab-button ${activeTab === 'projects' ? 'active' : ''}`}
//           onClick={() => setActiveTab('projects')}
//         >
//           Projects
//         </button>
//         <button 
//           className={`tab-button ${activeTab === 'contact' ? 'active' : ''}`}
//           onClick={() => setActiveTab('contact')}
//         >
//           Local Contact
//         </button>
//       </div>

//       {/* Tab Content */}
//       <div className="city-content">
//         {/* Overview Tab */}
//         {activeTab === 'overview' && (
//           <div className="tab-content">
//             <div className="overview-grid">
//               <div className="overview-card">
//                 <h2>Why Choose Solar in {city.title}?</h2>
//                 <p className="city-description">{city.detailedDescription}</p>
                
//                 <div className="key-sectors">
//                   <h3>Key Sectors in {city.title}</h3>
//                   <div className="sectors-grid">
//                     {city.keySectors.map((sector, index) => (
//                       <div key={index} className="sector-tag">
//                         {sector}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               <div className="overview-card">
//                 <h2>Solar Statistics</h2>
//                 <div className="stats-grid">
//                   <div className="stat-card">
//                     <div className="stat-icon">☀️</div>
//                     <h4>Solar Potential</h4>
//                     <p className="stat-value-large">{city.stats.solarPotential}</p>
//                     <p className="stat-desc">Average daily radiation</p>
//                   </div>
//                   <div className="stat-card">
//                     <div className="stat-icon">📊</div>
//                     <h4>Installed Capacity</h4>
//                     <p className="stat-value-large">{city.stats.installedCapacity}</p>
//                     <p className="stat-desc">Current solar capacity</p>
//                   </div>
//                   <div className="stat-card">
//                     <div className="stat-icon">🌿</div>
//                     <h4>CO₂ Reduction</h4>
//                     <p className="stat-value-large">{city.stats.co2Reduced}</p>
//                     <p className="stat-desc">Annual carbon savings</p>
//                   </div>
//                   <div className="stat-card">
//                     <div className="stat-icon">💰</div>
//                     <h4>Annual Savings</h4>
//                     <p className="stat-value-large">{city.stats.savings}</p>
//                     <p className="stat-desc">Collective customer savings</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Subsidy Information */}
//             <div className="subsidy-card">
//               <h3>💡 Solar Subsidy in {city.title}</h3>
//               <p>{city.subsidy}</p>
//               <Link to="/subsidy" className="subsidy-link">
//                 Check Your Subsidy Eligibility →
//               </Link>
//             </div>
//           </div>
//         )}

//         {/* Services Tab */}
//         {activeTab === 'services' && (
//           <div className="tab-content">
//             <h2>Our Services in {city.title}</h2>
//             <div className="services-grid">
//               {city.services.map((service, index) => (
//                 <div key={index} className="service-card">
//                   <div className="service-icon">
//                     {service.includes('Rooftop') ? '🏠' : 
//                      service.includes('Water') ? '💧' : 
//                      service.includes('Industrial') ? '🏭' : 
//                      service.includes('Street') ? '🛣️' : '☀️'}
//                   </div>
//                   <h3>{service}</h3>
//                   <p>Customized solutions for {city.title}'s specific needs</p>
//                   <Link to="/contact" className="service-cta">
//                     Get Quote
//                   </Link>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Projects Tab */}
//         {activeTab === 'projects' && (
//           <div className="tab-content">
//             <h2>Our Projects in {city.title}</h2>
//             <div className="projects-stats">
//               <div className="project-stat">
//                 <span className="project-count">{city.stats.projects}+</span>
//                 <span>Projects Completed</span>
//               </div>
//               <div className="project-stat">
//                 <span className="project-highlight">{city.highlight}</span>
//                 <span>Key Achievement</span>
//               </div>
//             </div>

//             <div className="testimonials-section">
//               <h3>What Our Customers Say</h3>
//               <div className="testimonials-grid">
//                 {city.testimonials.map((testimonial, index) => (
//                   <div key={index} className="testimonial-card">
//                     <p className="testimonial-text">"{testimonial}"</p>
//                     <div className="testimonial-author">
//                       <span className="author-role">Happy Customer</span>
//                       <span className="author-location">{city.title}</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Contact Tab */}
//         {activeTab === 'contact' && (
//           <div className="tab-content">
//             <div className="contact-grid">
//               <div className="contact-card">
//                 <h2>Local Office - {city.title}</h2>
//                 <div className="contact-info">
//                   <div className="contact-item">
//                     <span className="contact-icon">👤</span>
//                     <div>
//                       <strong>Contact Person:</strong>
//                       <p>{city.contactPerson}</p>
//                     </div>
//                   </div>
//                   <div className="contact-item">
//                     <span className="contact-icon">📞</span>
//                     <div>
//                       <strong>Phone:</strong>
//                       <p>{city.contactNumber}</p>
//                     </div>
//                   </div>
//                   <div className="contact-item">
//                     <span className="contact-icon">✉️</span>
//                     <div>
//                       <strong>Email:</strong>
//                       <p>{city.email}</p>
//                     </div>
//                   </div>
//                   <div className="contact-item">
//                     <span className="contact-icon">📍</span>
//                     <div>
//                       <strong>Office Address:</strong>
//                       <p>{city.officeAddress}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="contact-form-card">
//                 <h3>Quick Inquiry for {city.title}</h3>
//                 <form className="inquiry-form">
//                   <input type="text" placeholder="Your Name" required />
//                   <input type="tel" placeholder="Phone Number" required />
//                   <input type="email" placeholder="Email Address" required />
//                   <select>
//                     <option>Select Service</option>
//                     {city.services.map((service, index) => (
//                       <option key={index} value={service}>{service}</option>
//                     ))}
//                   </select>
//                   <textarea placeholder="Your requirements..." rows="3"></textarea>
//                   <button type="submit" className="submit-btn">
//                     Submit Inquiry
//                   </button>
//                 </form>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Call to Action */}
//       <div className="city-cta-section">
//         <div className="cta-content">
//           <h2>Ready to Go Solar in {city.title}?</h2>
//           <p>Get a free site assessment and customized solar solution for your property</p>
//           <div className="cta-buttons">
//             <Link to="/contact" className="cta-button primary">
//               Get Free Consultation
//             </Link>
//             <a href={`tel:${city.contactNumber}`} className="cta-button secondary">
//               Call Local Office
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Explore Other Cities */}
//       <div className="explore-cities">
//         <h3>Explore Our Presence in Other Cities</h3>
//         <div className="cities-grid">
//           {Object.keys(cityData).map((cityKey) => (
//             cityKey !== cityName?.toLowerCase() && (
//               <Link 
//                 key={cityKey} 
//                 to={`/city/${cityKey}`}
//                 className="city-link"
//               >
//                 {cityData[cityKey].title}
//               </Link>
//             )
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CityPage;